import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { UtmFunnel } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/utm-funnel")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <UtmFunnel />
    </RouteGuard>
  ),
});
